import React from "react";
import "./styles.styl";
import classNames from "classnames";

export default function CategoryNavItem({
  type,
  content,
  dataCategory,
  selected,
  canScrollLeft = true,
  canScrollRight = false,
}) {
  const styleMap = {
    title: "categorNavItem__title",
    category: "categorNavItem__maincategory",
    subcategory: "categorNavItem__subcategoryItem",
  };

  if (type === "subcategory" && !content) {
    return null;
  }
  return (
    <div
      className={classNames("categorNavItem__main", styleMap[type], {
        [`categorNavItem__${type}-selected`]: selected,
        "categorNavItem__l-0": canScrollLeft,
        "categorNavItem__r-0": canScrollRight,
      })}
      role="button"
      data-category={dataCategory}
    >
      {content}
    </div>
  );
}
